import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NAVEGATION } from 'src/app/shared/const/navegation';

@Component({
  selector: 'app-commodities',
  templateUrl: './commodities.component.html',
  styleUrls: ['./commodities.component.scss']
})
export class CommoditiesComponent {
  sellers: any;
  constructor(private router: Router) { }

  goToPriceBoard() {
    this.router.navigate(['/' + NAVEGATION.PRICE_BOARD]);
  }

}
